var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1197 0.177572C11.3898 0.427772 11.406 0.849579 11.1558 1.11969L5.15159 7.60193C4.65994 8.13273 3.84011 8.13273 3.34845 7.60193L0.844261 4.89833C0.594065 4.6282 0.610212 4.2064 0.880334 3.9562C1.15045 3.706 1.57225 3.7222 1.82245 3.99227L4.25002 6.61313L10.1776 0.213645C10.4278 -0.0564747 10.8496 -0.0726214 11.1197 0.177572ZM14.4534 0.177572C14.7234 0.427772 14.7396 0.849572 14.4894 1.11969L8.48522 7.60193C8.23502 7.872 7.81322 7.8882 7.54309 7.638C7.27295 7.3878 7.25682 6.966 7.50702 6.69587L13.5112 0.213645C13.7614 -0.0564747 14.1832 -0.0726214 14.4534 0.177572Z",
    fill: "#F98DA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishRed);
export default __webpack_public_path__ + "static/media/PublishRed.9504690714ccdcd398124c4e8b24069a.svg";
export { ForwardRef as ReactComponent };